module.exports = __webpack_public_path__ + "img/valu.a126051f.svg";